/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ average: NonNullable<unknown>, previous: NonNullable<unknown> }} Practice_Trend_LowerInputs */



/**
* | output |
* | --- |
* | "Average {average} — lower than {previous}" |
*
* @param {Practice_Trend_LowerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_trend_lower = /** @type {((inputs: Practice_Trend_LowerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Trend_LowerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Gemiddelde ${i?.average} — lager dan ${i?.previous}`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Moyenne ${i?.average} — moins bien que ${i?.previous}`)
	return /** @type {LocalizedString} */ (`Average ${i?.average} — lower than ${i?.previous}`)
});